<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal form-modal-wide">
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar persona contacto' : 'Nueva persona contacto' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <!-- === IDENTIFICACIÓN === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-person-badge"></i>
            Identificación
          </div>
          <div class="form-g3">
            <div class="mod-field">
              <label for="Clave">Clave <span class="mod-required">*</span></label>
              <input id="Clave" v-model="form.Clave" type="text" :disabled="isEdit" required maxlength="50" placeholder="Clave interna">
            </div>
            <div class="mod-field">
              <label for="TipoPersonaContacto">Tipo</label>
              <input id="TipoPersonaContacto" v-model="form.TipoPersonaContacto" type="text" list="tiposPersonaContacto" placeholder="Contratista, Gobierno, Residente...">
              <datalist id="tiposPersonaContacto">
                <option v-for="tipo in tipos" :key="tipo" :value="tipo"></option>
              </datalist>
            </div>
            <div class="mod-field mod-field-check form-check-end">
              <label class="mod-check-label">
                <input type="checkbox" v-model="form.EsActivo">
                <span>Activo</span>
              </label>
            </div>
          </div>
        </div>

        <!-- === DATOS PERSONALES === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-person"></i>
            Datos Personales
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="Nombre">Nombre <span class="mod-required">*</span></label>
              <input id="Nombre" v-model="form.Nombre" type="text" required placeholder="Nombre">
            </div>
            <div class="mod-field">
              <label for="Apellidos">Apellidos</label>
              <input id="Apellidos" v-model="form.Apellidos" type="text" placeholder="Apellidos">
            </div>
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="Cargo">Cargo</label>
              <input id="Cargo" v-model="form.Cargo" type="text" placeholder="Cargo o función">
            </div>
            <div class="mod-field">
              <label for="Departamento">Departamento</label>
              <input id="Departamento" v-model="form.Departamento" type="text" placeholder="Área o departamento">
            </div>
          </div>
        </div>

        <!-- === EMPRESA / VÍNCULO === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-building"></i>
            Empresa / Vínculo
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="EmpresaNombre">Empresa / Institución</label>
              <input id="EmpresaNombre" v-model="form.EmpresaNombre" type="text" placeholder="Empresa o institución">
            </div>
            <div class="mod-field">
              <label for="SocioNegocioClave">Socio de Negocio</label>
              <CatSearch
                id="SocioNegocioClave"
                catalogo="socionegocio"
                v-model="form.SocioNegocioClave"
                placeholder="Buscar cliente / proveedor..."
                @select="onSelectSocioNegocio"
              />
            </div>
          </div>
        </div>

        <!-- === CONTACTO === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-telephone"></i>
            Contacto
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="Email">Email</label>
              <input id="Email" v-model="form.Email" type="email" placeholder="correo@empresa.com">
            </div>
            <div class="mod-field">
              <label for="EmailAlterno">Email Alterno</label>
              <input id="EmailAlterno" v-model="form.EmailAlterno" type="email" placeholder="correo alterno">
            </div>
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="Telefono">Teléfono</label>
              <input id="Telefono" v-model="form.Telefono" type="text" placeholder="Teléfono">
            </div>
            <div class="mod-field">
              <label for="Celular">Celular</label>
              <input id="Celular" v-model="form.Celular" type="text" placeholder="Celular">
            </div>
          </div>
        </div>

        <!-- === UBICACIÓN === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-geo-alt"></i>
            Ubicación
          </div>
          <div class="mod-field">
            <label for="Direccion">Dirección</label>
            <input id="Direccion" v-model="form.Direccion" type="text" placeholder="Dirección completa">
          </div>
          <div class="form-g4" style="margin-top: 0.75rem">
            <div class="mod-field">
              <label for="Ciudad">Ciudad</label>
              <input id="Ciudad" v-model="form.Ciudad" type="text" placeholder="Ciudad">
            </div>
            <div class="mod-field">
              <label for="Estado">Estado</label>
              <input id="Estado" v-model="form.Estado" type="text" placeholder="Estado">
            </div>
            <div class="mod-field">
              <label for="PaisClave">País</label>
              <input id="PaisClave" v-model="form.PaisClave" type="text" maxlength="10" placeholder="MX">
            </div>
            <div class="mod-field">
              <label for="CodigoPostal">C.P.</label>
              <input id="CodigoPostal" v-model="form.CodigoPostal" type="text" placeholder="C.P.">
            </div>
          </div>
        </div>

        <!-- === ERP / SISTEMA === -->
        <div class="form-section">
          <div class="form-section-hdr">
            <i class="bi bi-hdd-network"></i>
            ERP / Sistema
          </div>
          <div class="form-g2">
            <div class="mod-field">
              <label for="ClaveErp">Clave ERP</label>
              <input id="ClaveErp" v-model="form.ClaveErp" type="text" placeholder="Mapeo con ERP">
            </div>
            <div class="mod-field">
              <label for="OrigenErp">Origen ERP</label>
              <input id="OrigenErp" v-model="form.OrigenErp" type="text" placeholder="SAPB1, Odoo, manual...">
            </div>
          </div>
          <div class="mod-field">
            <label for="Notas">Notas</label>
            <textarea id="Notas" v-model="form.Notas" rows="2" placeholder="Notas internas"></textarea>
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear contacto' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import personaContactoService from './personacontacto.service';
import { createPersonaContacto, tiposPersonaContacto } from './personacontacto.model';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import CatSearch from '@/shared/components/CatSearch.vue';

export default {
  name: 'PersonaContactoForm',
  components: { CatSearch },
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createPersonaContacto(),
      tipos: tiposPersonaContacto,
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    onSelectSocioNegocio(item) {
      this.form.SocioNegocioClave = item.Clave || '';
      if (!this.form.EmpresaNombre) this.form.EmpresaNombre = item.Nombre || '';
    },
    async handleSubmit() {
      this.saving = true;
      this.error = null;
      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }
      try {
        const result = await personaContactoService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch {
        this.error = 'Error de conexión con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

/* ── Modal ampliado ─────────────────────────────────── */
.form-modal-wide {
  max-width: 780px;
}

/* ── Secciones ──────────────────────────────────────── */
.form-section {
  border: 1px solid #e8eef5;
  border-radius: 8px;
  padding: 0.875rem 1rem 1rem;
  background: #ffffff;
  margin-bottom: 0.75rem;
}

.form-section:last-of-type {
  margin-bottom: 0;
}

.form-section-hdr {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--t-primary, #1272c4);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 0.875rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #edf2f7;
}

.form-section-hdr i {
  font-size: 0.8rem;
}

/* ── Grid layouts ───────────────────────────────────── */
.form-g2,
.form-g3,
.form-g4 {
  display: grid;
  gap: 0.75rem 1rem;
  margin-bottom: 0.75rem;
}

.form-g2 { grid-template-columns: repeat(2, 1fr); }
.form-g3 { grid-template-columns: repeat(3, 1fr); }
.form-g4 { grid-template-columns: repeat(4, 1fr); }

.form-g2:last-child,
.form-g3:last-child,
.form-g4:last-child {
  margin-bottom: 0;
}

/* Checkbox alineado al fondo */
.form-check-end {
  align-self: end;
  padding-bottom: 0.45rem;
}

/* ── Textarea ───────────────────────────────────────── */
.mod-field textarea {
  width: 100%;
  padding: 0.6rem 0.85rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  font-family: inherit;
  color: #2d3748;
  background: #ffffff;
  resize: vertical;
  transition: border-color 0.2s;
}

.mod-field textarea:focus {
  outline: none;
  border-color: var(--t-border-focus, #1272c4);
  box-shadow: 0 0 0 3px var(--t-primary-ring, rgba(18, 114, 196, 0.1));
}

/* ── Responsive ─────────────────────────────────────── */
@media (max-width: 640px) {
  .form-g2,
  .form-g3,
  .form-g4 {
    grid-template-columns: 1fr;
  }
}
</style>
